import { render, staticRenderFns } from "./setDisplayName.vue?vue&type=template&id=3e64d236"
import script from "./setDisplayName.vue?vue&type=script&lang=js"
export * from "./setDisplayName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports